import { getItemById, putInStore, openDatabase, ifOffline } from "../../db";

export const OBJECTSTORE_DETAILS_ACTIVITIES = "installation_activities";

export const saveActivities = (instPlan_id, data) => {
  return new Promise((resolve, reject) => {
    let obj = {
      id: instPlan_id,
      data: data,
    };
    ifOffline(instPlan_id, obj)
      .then((data) => putInStore(OBJECTSTORE_DETAILS_ACTIVITIES, data))
      .then((k) => resolve(true))
      .catch(reject);
  });
};

export const getActivities = (instPlan_id) => {
  return new Promise((resolve, reject) => {
    getItemById(OBJECTSTORE_DETAILS_ACTIVITIES, instPlan_id)
      .then((obj) => resolve(obj.data))
      .catch(reject);
  });
};

export const updateActivitiesOffline = (instPlan_id, activity_id, updateObj) => {
  return new Promise((resolve, reject) => {
    getItemById(OBJECTSTORE_DETAILS_ACTIVITIES, instPlan_id)
      .then((obj) => {
        // getting data out
        let data = obj.data;

        let k = data.find((o, i) => o.id === activity_id);
        let index = data.indexOf(k);
        obj["data"][index] = { ...obj["data"][index], ...updateObj };

        openDatabase().then((db) => {
          if (!db) return reject(false);
          db.onsuccess = function (event) {
            let db = event.target.result;
            let tx = db.transaction(OBJECTSTORE_DETAILS_ACTIVITIES, "readwrite");
            let objectStore = tx.objectStore(OBJECTSTORE_DETAILS_ACTIVITIES);
            objectStore.put(obj);
            tx.oncomplete = (e) => resolve();
            tx.onerror = (e) => reject();
          };
        });
      })
      .catch((err) => {
        return reject();
      });
  });
};
